var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 460,
    height: 276,
    viewBox: "0 0 460 276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-638 -371) translate(583 371) translate(55) translate(0 80) translate(0 158)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.5,
    cy: 34.5,
    fill: "#2F2E41",
    rx: 5.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.5,
    cy: 34.5,
    fill: "#2F2E41",
    rx: 5.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M4.914 25.707C12.491 35.925 28.22 37 28.22 37s3.444-15.49-4.133-25.707C16.509 1.075.78 0 .78 0s-3.444 15.49 4.133 25.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M42.78 29.675C37.816 36.302 27.512 37 27.512 37s-2.257-10.048 2.708-16.675C35.184 13.698 45.488 13 45.488 13s2.257 10.048-2.708 16.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#354053",
    d: "M4 36H418V38H4z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E6E6E6",
    opacity: 0.2,
    transform: "translate(-638 -371) translate(583 371) translate(55) translate(0 80) translate(20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 46,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 67,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 88,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 108,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 129,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 150,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 171,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 192,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 192,
    r: 4
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M407 264.5c-1.498 13.215-80.119 12.106-80 0 1.498-13.215 80.119-12.106 80 0z",
    transform: "translate(-638 -371) translate(583 371) translate(55)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-638 -371) translate(583 371) translate(55) translate(27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M0 0H368V236H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11 30H358V120H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M97 43H170V47H97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M97 58H210V62H97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M97 73H189V77H97zM97 87H151V91H97zM97 102H178V106H97zM64 41H73V50H64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M64 56H73V65H64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M64 70H73V79H64zM64 85H73V94H64zM64 99H73V108H64zM279 62H309V92H279z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11 132H358V222H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M79 140H88V149H79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M64 140H73V149H64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M216.482 160c-5.591-9.581-15.387-15.863-26.334-16.886-10.947-1.024-21.714 3.335-28.944 11.717l-2.204-1.95c7.847-9.1 19.534-13.832 31.417-12.721 11.882 1.11 22.515 7.93 28.583 18.331L216.482 160z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M217.504 198L215 196.392c7.567-10.779 7.988-24.748 1.082-35.924l2.596-1.468c7.499 12.133 7.042 27.299-1.174 39zM159.756 202c-12.887-13.914-13.022-34.933-.314-49l2.269 1.917c-11.707 12.959-11.583 32.322.289 45.14L159.756 202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98A",
    d: "M186.428 214c-10.469-.008-20.44-4.486-27.428-12.318l2.16-1.943c6.983 7.84 17.18 11.997 27.627 11.266 10.447-.73 19.972-6.269 25.807-15.005l2.406 1.625c-6.835 10.239-18.3 16.38-30.572 16.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M279 160H309V190H279zM62 179H92V209H62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAC5FF",
    d: "M0 0H368V16H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 8,
    r: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 8,
    r: 3,
    fill: "#FFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateIllustration);
export default __webpack_public_path__ + "static/media/empty-state-illustration.4955ebbd.svg";
export { ForwardRef as ReactComponent };